import { Component,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-bloqueo',
  template: `
      <div *ngIf="visible" >
        <div class="divCargando ">
          <mat-spinner matSuffix  class="col-md-12 mx-auto"></mat-spinner>
        </div>
      </div>
  `,
  styles: [`
        .divCargando{
          background: rgba(255,255,255,0.8);
          align-items: center;
          text-align: center;
          width: 100%;
          height: 100%;
          z-index: 900000;
          top:0;
          left:0;
          overflow-y: hidden;
          position: fixed;
          display: grid;
        }
  `]
})
export class BloqueoComponent {
  @Input() public visible:boolean = false;
  @Output() public retornoVisible = new EventEmitter();


  terminarBloqueo(){
    console.log("entro a sppiner");
    this.visible = false;
    this.retornoVisible.emit({visible:false});
  }

  constructor() { }


}
